import PropTypes from 'prop-types';
import Ad from '../Ad/Ad';
import { AdSizes } from '../Ad/AdSizes';
import RightRail from '../RightRail/RightRail';
import ArticleHeader from '../article/ArticleHeader';
import RelatedContent from '../RelatedContent/RelatedContent';
import SponsorAd from '../Ad/SponsorAd';

export default function TwoColumnLayout({
	article,
	children,
	className = null,
	preHeaderContent: PreHeaderContent,
	preFooterContent: PreFooterContent,
}) {
	const cssClasses = `article ${className || 'post_type_post'}`;

	return (
		<>
			{PreHeaderContent && <PreHeaderContent />}
			<Ad
				sizes={{
					'xs sm': AdSizes.MOBILE_LEADERBOARD,
					'md lg': AdSizes.LEADERBOARD,
					'xl xxl': AdSizes.LEADERBOARD_COMBO,
				}}
				htmlId="article-leaderboard-ad"
				wrapperClass="article-leaderboard-ad leaderboard-ad"
			/>
			<SponsorAd />
			<article className={cssClasses}>
				<ArticleHeader article={article} />
				<div className="article-body-wrapper">
					{children}
					<RightRail article={article} />
				</div>
			</article>
			<RelatedContent article={article} />
			{PreFooterContent && <PreFooterContent />}
		</>
	);
}

TwoColumnLayout.propTypes = {
	children: PropTypes.shape({}).isRequired,
	article: PropTypes.object.isRequired,
	className: PropTypes.string,
	preHeaderContent: PropTypes.func,
	preFooterContent: PropTypes.func,
};
